import React, { useState } from 'react';
import { useEffect } from 'react';

export const CartContext = React.createContext();
export const titles = [
  { id: 0, label: "Miss" },
  { id: 1, label: "Ms" },
  { id: 2, label: "Mrs" },
  { id: 3, label: "Mr" },
  { id: 4, label: "Dr" },
];

export const guestTypes = {
  adult: "Adult",
  senior: "Senior",
  child: "Child",
  juniorchild: "JuniorChild",
  infant: "Infant",
};

export const CartProvider = (props) => {

  const [cart, setCart] = useState(
    JSON.parse(sessionStorage.getItem('cart'))
    ||
    {
      totalPrice: 0,
      masterId: 0,
      packageId: 0,
      name: "",
      departure: null,
      duration: 0,
      ship: "",
      cruiseline: "",
      cabins:
        [{
          price: 0,
          cabintypeId: 0,
          cabintypeName: "",
          deckId: 0,
          cabinId: "",
          adults: 2,
          seniors: 0,
          children: 0,
          juniorChildren: 0,
          infants: 0,
          mainGuest:
          {
            title: null,
            firstName: "",
            lastName: "",
            dateOfBirth: null,
            nationality: "",
            email: "",
            phone: "",
            address:
            {
              street: "",
              city: "",
              zipCode: ""
            },
            createProfile: true,
          },
          additionalGuests:
            [{
              guestType: null,
              title: null,
              firstName: "",
              lastName: "",
              dateOfBirth: null,
              nationality: "",
            }],
        }],
    });
  useEffect(() => {
    sessionStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);
  return (
    <CartContext.Provider value={[cart, setCart]}>
      {props.children}
    </CartContext.Provider>
  );
};